module.exports = __webpack_public_path__ + "img/H1M5.70337e63.jpg";